import { render, staticRenderFns } from "./MeasurementDataTableTab.vue?vue&type=template&id=25d41fed&scoped=true&"
import script from "./MeasurementDataTableTab.vue?vue&type=script&lang=js&"
export * from "./MeasurementDataTableTab.vue?vue&type=script&lang=js&"
import style0 from "./MeasurementDataTableTab.vue?vue&type=style&index=0&id=25d41fed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d41fed",
  null
  
)

export default component.exports